import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'

import { TypingService } from './typing.service'
@NgModule({
  imports: [
    CommonModule,
  ],
  providers: [
    TypingService
  ]
})
export class SignalModule {
}



// WEBPACK FOOTER //
// ./src/app/shared/signalR/signalR.module.ts